// This file holds our state type, as well as any other types related to this Redux store.

// Response object for GET /Company
// https://docs.opendota.com/#tag/Company%2Fpaths%2F~1Company%2Fget

export interface LookupField{
  id:number
  name:string
}
export interface Company {
  id: number
  name: string
  companyCode?:string
  region?: string
  country?:string
  preparer?: LookupField
  reviewer?: LookupField
  approver?: LookupField
  roles: LookupField[]
  
  }
  
  // This type is basically shorthand for `{ [key: string]: any }`. Feel free to replace `any` with
  // the expected return type of your API response.
  export type ApiResponse = Record<string, any>
  
  // Use `enum`s for better autocompletion of action type names. These will
  // be compiled away leaving only the final value in your compiled code.
  //
  // Define however naming conventions you'd like for your action types, but
  // personally, I use the `@@context/ACTION_TYPE` convention, to follow the convention
  // of Redux's `@@INIT` action.
  export enum CompanyActionTypes {
    FETCH_REQUEST = '@@Company/FETCH_REQUEST',
    FETCH_SUCCESS = '@@Company/FETCH_SUCCESS',
    FETCH_ERROR = '@@Company/FETCH_ERROR',
    
    SELECT_COMPANY = '@@Company/SELECT_Company',
    SELECTED = '@@Company/SELECTED',
    CLEAR_SELECTED = '@@Company/CLEAR_SELECTED',
    ADD_SUCCESS = '@@Company/ADD_SUCCESS',

    EDIT = '@@Company/EDIT',
    UPDATE_EDIT = '@@Company/UPDATE_EDIT',
    EDIT_SUCCESS = '@@Company/EDIT_SUCCESS'
  }
  
  // Declare state types with `readonly` modifier to get compile time immutability.
  // https://github.com/piotrwitek/react-redux-typescript-guide#state-with-type-level-immutability
  export interface CompanyState {
    readonly loading: boolean
    readonly selected?: number
    readonly errors?: string

  }
  
  export interface CompanySelectedPayload{
    detail:Company
    submissionYear: string[]
  }